<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">This is dedicated to my five daughters, who have been my inspiration, based on my ownership of eleven fishing boats during my working life.</p>
<p class="iim" style="text-align: center;margin-top:25px;margin-bottom:25px;"><img alt="" src="media/file1.jpg" style="width:4.19332in;height:3.17843in;filter:grayscale(100%);"/></p>
<p>From left to right: Dena, Michelle, Deborah, Yvette, Lucy.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?5c05bcd7